<template>
  <v-container>
    <v-row dense>
      <v-col cols="12" class="pb-3">
        <div class="text-h6">
          Presiona el botón para agregar un productor o una empresa
        </div>
      </v-col>
     <v-row>
  <v-col v-if="user_can.add" cols="auto" class="d-flex justify-start">
    <v-btn router to="/ru/productor" depressed class="primary">
      Agregar Productor
    </v-btn>
  </v-col>

  <!-- Fila vacía o margen adicional entre los botones -->
  <v-col v-if="user_can.add" cols="1"></v-col> <!-- Espacio entre los botones -->

  <v-col v-if="user_can.add" cols="auto" class="d-flex justify-end">
    <v-btn router to="/ru/productor/empresa" depressed class="primary">
      AGREGAR EMPRESA
    </v-btn>
  </v-col>
</v-row>
      <v-col cols="12" class="tt">
        <div class="text-h6">Lista de productores o empresas</div>
        <div class="text-h8">Presione el productor o empresas para ver la información o modificarlo.</div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
       <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas  -->
      <v-col v-if="Object.keys(productores).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aun no tienes ningún productor o empresa 
        </div>
      </v-col>
     <!-- <v-col cols="12" class="mt-4"></v-col> -->
      <!-- listado de productores en el almacenamiento local -->
      <!-- <v-col cols="12">Selecciona al Productor para Modificarlo:</v-col> -->
      <v-col cols="12" class="lista">
        <v-list two-line>
          <template v-for="(productor, index) in productores">
            <form-card
              :key="productor.id"
              :top-text="`${productor.primer_nombre} ${productor.primer_apellido}`"
              :middle-text="productor.id"
              :sincronized="productor.sincronizado"
              @click="traerRegistroYNavegar(productor)"
            >
              <template v-slot:avatar>
                <v-list-item-avatar>
                  <v-menu offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon v-text="'mdi-dots-vertical'" />
                      </v-btn>
                    </template>
                    <v-card class="pa-3">
                      <v-row class="py-1">
                        <v-btn
                          v-if="productor.sincronizado"
                          class="success--text"
                          text
                          block
                          small
                          :disabled="loading_add"
                          @click.stop="
                            cargarProductor(
                              productor,
                              fechaproddesde,
                              fechaprodhasta
                            )
                          "
                        >
                          <v-icon left v-text="'mdi-reload'" />
                          Cargar expediente nuevamente
                        </v-btn>
                      </v-row>
                      <v-row class="py-1">
                        <v-btn
                          :key="`v-btn-${index}`"
                          :loading="loading_delete"
                          block
                          small
                          class="error--text"
                          text
                          @click="eliminarTodoDe(productor.id)"
                        >
                          <v-icon left v-text="'mdi-delete'" />
                          Archivar Expediente
                        </v-btn>
                      </v-row>
                    </v-card>
                  </v-menu>
                </v-list-item-avatar>
              </template>
            </form-card>
          </template>
        </v-list>
      </v-col>
      <!-- 
      <v-col cols="6" md="3">
        <v-text-field
          v-model="ruc"
          :rules="[r.max(23)]"
          outlined
          label="RUC"
          name="ruc"
          @keyup.enter="buscarProductores"
        ></v-text-field>
      </v-col>
      <v-col cols="6" md="3">
        <v-text-field
          v-model="nombre"
          :rules="[r.name]"
          outlined
          label="Nombre"
          name="nombre"
          @keyup.enter="buscarProductores"
        ></v-text-field>
      </v-col>
      <v-col cols="6" md="3">
        <v-text-field
          v-model="apellido"
          :rules="[r.name]"
          outlined
          label="Apellido"
          name="apellido"
          @keyup.enter="buscarProductores"
        ></v-text-field>
      </v-col> -->
      <!-- <v-col cols="6">
        <div class="text-h8">Fecha de Producciones desde:</div>
      </v-col> -->
      <!-- Fecha hasta -->
      <!--   <v-col cols="6" md="6">
            <n-date :date.sync="datehasta" label="Producciones Hasta" 
             @change="cambiaFechaString" />
      </v-col> -->
      <v-col cols="12" md="3">
        <v-text-field
          v-model="id"
          :rules="[r.max(23)]"
          label="Céd"
          name="cedula"
          @keyup.enter="buscarProductores"
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-btn
          :loading="loading_search"
          depressed
          block
          class="primary"
          @click="buscarProductores"
        >
          <v-icon left>mdi-magnify</v-icon>
          Buscar
        </v-btn>
      </v-col>
             
      <v-col cols="12">
        <v-data-iterator :items="listado_productores" :options="options">
          <template v-slot:item="props">
            <v-list-item :key="props.item.id">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold"
                  >{{ props.item.primer_nombre || '' }}
                  {{ props.item.primer_apellido || '' }}</v-list-item-title
                >
                <v-list-item-subtitle class="text-body-2 blue-grey--text"
                  >{{ props.item.id }}
                </v-list-item-subtitle>
                <v-list-item-subtitle
                  v-if="existsInDevice(props.item.id)"
                  class="orange--text text-body-2"
                  >Este productor ya está agregado en el
                  dispositivo</v-list-item-subtitle
                >
              </v-list-item-content>
            
            </v-list-item>
            <v-divider :key="`v-divider-${props.item.id}`"></v-divider>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import moment from 'moment'
import { mapGetters } from 'vuex'
import * as rules from '@/utils/validations'

export default {
  name: 'Productores',
  data: () => {
    const fechaActual = new Date()
    const fechaDesde = new Date()
    fechaDesde.setMonth(fechaDesde.getMonth() - 6)
    const fdesde = fechaDesde.toISOString().split('T')[0] // Formato "YYYY-MM-DD"
    const fhasta = fechaActual.toISOString().split('T')[0]
    return {
      r: rules,
      options: {
        itemsPerPage: 10,
      },
      //productor: {},
      listado_productores: [],
      id: '',
      nombre: '',
      apellido: '',
      ruc: '',
      fechaproddesde: fdesde,
      fechaprodhasta: fhasta,
      loading_search: false,
      loading_add: false,
      loading_delete: false,
      error: '',
      errorhas: '',
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),

    productores() {
      return this.$store.state.registros.productores
    },
    ...mapGetters('registros', ['id_productores']),

    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  async mounted() {
    this.$store.commit('ui/updateToolbar', 'Productores')
    await this.buscarProductores()
    
     if (this.listado_productores.length > 0) {
      await this.cargarTodosProductores()
     } else { 
      // this.$router.push('/ru/productor')
     }
  },
  
  methods: {
    /* validarFecha() {
      // Verificar si la fecha tiene el formato yyyy-mm-dd
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regexFecha.test(this.fechaproddesde)) {
        this.error =
          'Favor colocar año. mes y dia separado con guiones asi: yyyy-mm-dd'
      } else {
        // Si el formato es correcto, convierte la cadena de fecha en un objeto Date
        let [, anio, mes, dia] = this.fechaproddesde.match(regexFecha)
        // Verificar si el mes es válido (entre 1 y 12)
        if (parseInt(mes) < 1 || parseInt(mes) > 12) {
          this.error = 'El mes debe estar en el rango de 1 a 12.'
          return
        }
        // Verificar si el día es válido para el mes correspondiente
        let diasEnMes = new Date(anio, mes, 0).getDate() // Obtener el número de días en el mes
        if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
          this.error = 'El día no es válido para el mes especificado.'
          return
        }
        // Si todos los controles pasan, la fecha es válida
        this.error = ''
        console.log('Fecha válida:', this.fechaproddesde)
      }
    },
    validarFechahas() {
      // Verificar si la fecha tiene el formato yyyy-mm-dd
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regexFecha.test(this.fechaprodhasta)) {
        this.errorhas =
          'Favor colocar año. mes y dia separado con guiones asi: yyyy-mm-dd'
      } else {
        // Si el formato es correcto, convierte la cadena de fecha en un objeto Date
        let [, anio, mes, dia] = this.fechaprodhasta.match(regexFecha)
        // Verificar si el mes es válido (entre 1 y 12)
        if (parseInt(mes) < 1 || parseInt(mes) > 12) {
          this.errorhas = 'El mes debe estar en el rango de 1 a 12.'
          return
        }
        // Verificar si el día es válido para el mes correspondiente
        let diasEnMes = new Date(anio, mes, 0).getDate() // Obtener el número de días en el mes
        if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
          this.errorhas = 'El día no es válido para el mes especificado.'
          return
        }
        // Si todos los controles pasan, la fecha es válida
        this.errorhas = ''
        console.log('Fecha válida:', this.fechaproddesde)
      }
    }, */
    existsInDevice(id = 0) {
      return this.id_productores.includes(id)
    },
    
    async eliminarTodoDe(id_productor) {
      try {
        this.loading_delete = true
        await this.$store.dispatch(
          'registros/eliminarDatosDeProductor',
          id_productor
        )
        this.loading_delete = false
      } catch (e) {
        this.loading_delete = false
      }
    },
    async buscarProductores() {
      try {
        this.loading_search = true
        const res = await this.$store.dispatch('registros/listarCompasVarios', {
          cnameagru: this.user.cnameagru,
          id: this.id,
        })
        const { status, data } = res
        if (status === 'ok') {
          this.listado_productores = data
        }
        this.loading_search = false
      } catch (e) {
        this.loading_search = false
      }
    },
    /*  async cambiaFechaString() {
      this.fechaproddesde = this.datedesde.toString();
      this.fechaprodhasta = this.datehasta.toString();
      //alert(this.fechaproddesde)
    }, */

    async cargarTodosProductores() {
      const fechaDesde = new Date()
      fechaDesde.setMonth(fechaDesde.getMonth() - 6)
      const fdesde = fechaDesde.toISOString().split('T')[0]
      const fechaproddesde = fdesde
      const fhasta = new Date()
      const fechaprodhasta = fhasta.toISOString().split('T')[0]
      try {
        // Usamos Promise.all para esperar que todas las promesas se resuelvan
        await Promise.all(
          this.listado_productores.map((item) =>
            this.cargarProductor(item, fechaproddesde, fechaprodhasta)
          )
        )
        //console.log('Todos los productores han sido cargados')
      } catch (e) {
        console.error('Error al cargar todos los productores:', e)
      }
    },

    async cargarProductor(productor, fechapdesde, fechaphasta) {
      try {
        this.loading_add = true
        //console.log('cargarproductor=' + productor.id + fechapdesde + fechaphasta)

        await this.$store.dispatch('registros/getExpediente', {
          id_productor: String(productor.id),
          fechaproddesde: fechapdesde,
          fechaprodhasta: fechaphasta,
        })
        this.$store.commit('ui/setSnack', {
          text: 'Datos agregados al dispositivo',
        })
      } catch (e) {
        console.error('Error al cargar productor:', e)
      } finally {
        this.loading_add = false
      }
    },

    /*async mostrarProductor(productor) {
      this.loading_add = true
      await this.$store.dispatch('registros/getProductor', {
        id: productor.id,
      })
      this.$router.push(`/ru/productor/${productor.id}`)
    },*/
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getProductor', {
          id: registro.id,
        })
      }
      this.$router.push(`/ru/productor/${registro.id}`)
    },
  },
}
</script>
<style scoped>
.formato-fecha {
  color: grey;
}
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>
